import { GET_SCALP_CAMERA } from '../constants';
import { getContent } from '../../services/api';

const scalpCamera = locale => ({
  type: GET_SCALP_CAMERA,
  payload: getContent({ contentType: 'scalpCameraDiagnosis', locale }),
});

export default scalpCamera;



// WEBPACK FOOTER //
// ./src/redux/actions/scalpCamera.js